import type IBlogPost from "@api/models/IBlog";
import { Group, ThemeIcon } from "@mantine/core";
import AppSkeleton from "@modules/loader/AppSkeleton";
import { IconAlarm } from "@tabler/icons-react";

interface Props {
  blog?: IBlogPost;
}

const ReadingTime: React.FC<Props> = ({ blog }) => {
  return (
    <Group className="text-primary-dark-text text-sm" gap={5}>
      <ThemeIcon
        autoContrast
        className="text-primary-dark-text"
        variant="transparent"
      >
        <IconAlarm />
      </ThemeIcon>
      <AppSkeleton>
        <span>{blog?.timeToRead} mins de lecture</span>
      </AppSkeleton>
    </Group>
  );
};

export default ReadingTime;
